/**
 * The active banner was previously controlled by the LaunchDarkly
 * `cloud-dashboard-active-banner` flag. In production it evaluated to no active
 * banner, so this now always renders nothing.
 */
export const Banner = () => null;
